import React, { useMemo } from 'react';
import { Modal } from 'lmc-ui-library';
import { RootState } from 'store/configureStore';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from 'components/Loader/Loader';

import { State, AvailableModalActions } from './store';
import { Actions, GeneralError, SendToPepperErrors, ValidationFailed, ValidationSuccess } from './modalContents';
import UWModal from 'modules/cm/components/UWModal/UWModal';
import { PepperUploadPreviewSummary } from 'modules/cm/pages/CaseDetailsPage/partials';
import { closeReview } from 'modules/cm/pages/CaseDetailsPage/Pepper/store/useCases';

interface Props {
  onClose: () => void;
  isDisabledSendToPepperButton: boolean;
}

const PepperModal = ({ onClose, isDisabledSendToPepperButton }: Props) => {
  const dispatch = useDispatch();
  const isPepperActionsModalOpen = useSelector((state: any) => {
    return state.cmPepper.isModalOpen;
  });

  const { currentModalAction, send, reviewAction, validateDataAction } = useSelector((state: RootState) => {
    return state.cmPepper as NonNullable<State>;
  });

  const shouldShowCloseButton = useMemo(() => {
    return [AvailableModalActions.SELECT_ACTIONS].includes(currentModalAction);
  }, [currentModalAction]);

  return (
    <>
      {reviewAction.isModalOpen && (
        <UWModal title="Upload preview" isOpen={true} onCloseButtonClick={dispatch.bind(null, closeReview())}>
          <PepperUploadPreviewSummary />
        </UWModal>
      )}
      <Modal showCloseBtn={shouldShowCloseButton} isOpen={isPepperActionsModalOpen} onClose={onClose}>
        {send.isPending || validateDataAction.isPending ? (
          <Loader />
        ) : (
          <>
            {currentModalAction === AvailableModalActions.GENERAL_ERROR && <GeneralError />}
            {currentModalAction && currentModalAction === AvailableModalActions.SELECT_ACTIONS && (
              <Actions isDisabledSendToPepperButton={isDisabledSendToPepperButton} />
            )}
            {currentModalAction === AvailableModalActions.SEND_ERRORS && <SendToPepperErrors errors={send.errors} />}
            {currentModalAction === AvailableModalActions.VALIDATE_FAILED && <ValidationFailed />}
            {currentModalAction === AvailableModalActions.VALIDATE_OK && <ValidationSuccess />}
          </>
        )}
      </Modal>
    </>
  );
};

export default PepperModal;
